import { render, staticRenderFns } from "./ObjectTab.vue?vue&type=template&id=27ba938a&scoped=true"
import script from "./ObjectTab.vue?vue&type=script&lang=ts"
export * from "./ObjectTab.vue?vue&type=script&lang=ts"
import style0 from "./ObjectTab.vue?vue&type=style&index=0&id=27ba938a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ba938a",
  null
  
)

export default component.exports